import { Button, Table } from "antd";
import React, { useState } from "react";
import { Worker } from "../../Models/Worker";
import { WorkerFilter } from "../../Views/Workers/WorkersView";
import { PlusOutlined } from "@ant-design/icons";
import GenerateScheduleModal from "./GenerateScheduleModal";

interface Props {
  workers: Worker[];
  filter: WorkerFilter[];
}

interface RowType extends Worker {
  counter: number;
}

type FilterType = string | number | boolean;

function WorkersTable(props: Props) {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (
    newSelectedRowKeys: React.Key[],
    rows: any,
    info: any
  ) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys, info);
    if (info.type === "single") {
      setSelectedRowKeys(newSelectedRowKeys);
    }
  };

  const onSelectAll = (
    selected: boolean,
    selectedRows: RowType[],
    changeRows: RowType[]
  ) => {
    if (!selected) {
      console.log("HELLO");
      setSelectedRowKeys([]);
    } else {
      setSelectedRowKeys(selectedRows.map((row) => row.id));
    }
    console.log("ON SELECT ALL", selected);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    onSelectAll: onSelectAll,
  };

  const hasSelected = selectedRowKeys.length > 0;

  const RenderTable = (workers: Worker[]) => {
    let data: RowType[] = workers
      .filter((row) => {
        if (props.filter.includes(WorkerFilter.ALL)) {
          return true;
        }
        //const hasApple = arr.some(item => item.name === "Apple");
        return row.positions.some((item) => item.title.includes("Pakendaja"));
      })
      .map((p, idx) => {
        return {
          ...p,
          counter: idx + 1,
        };
      });

    const columns = [
      {
        title: "#",
        dataIndex: "counter",
        key: "counter",
        render: (count: number) => <strong>{count}</strong>,
      },
      {
        title: "Nimi",
        dataIndex: "name",
        key: "name",
        render: (_: string, row: RowType) => (
          <strong>
            {row.name} {row.lastName} ({row.nickName})
          </strong>
        ),
      },
      {
        title: "Positsioonid",
        dataIndex: "positions",
        key: "positions",
        render: (_: string, row: RowType) => (
          <strong>{row.positions.map((p) => p.title).join(", ")}</strong>
        ),
      },
    ];

    const selectedWorkers = props.workers.filter((w) =>
      selectedRowKeys.includes(w.id)
    );

    return (
      <>
        {selectedRowKeys.length > 5 && (
          <GenerateScheduleModal workers={selectedWorkers} />
        )}
        <Table
          className="table-striped-rows"
          columns={columns}
          dataSource={data}
          rowKey={"id"}
          pagination={false}
          rowSelection={rowSelection}
        />
      </>
    );
  };

  return RenderTable(props.workers);
}
export default WorkersTable;
